import { CloseIcon } from '../lib/CloseIcon'
import { ChristmasGift } from './types'
import { GIFTS, INVOICE_STATUSES, ORDER_STATUSES, reverseDate } from './util'

type Props = {
  onClose: () => void
  onSave: (gift: ChristmasGift) => void
  selected: ChristmasGift
  setSelected: (gift: ChristmasGift) => void
}

export function EditModal({ onClose, selected, setSelected, onSave }: Props) {
  return (
    <>
      <div className="cg-modal-background"></div>
      <div className="cg-modal-dialog">
        <div className="cg-modal-title">
          <div className="flex flex-justify-between flex-align-center">
            <div>Edit details</div>
            <div className="cg-close" onClick={() => onClose()}>
              <CloseIcon width={22} height={22} />
            </div>
          </div>
        </div>
        <div className="cg-modal-content flex flex-col" style={{ gap: 5 }}>
          <div className="cg-modal-subtitle">Request by</div>
          <div className="flex">
            <div style={{ width: 150 }}>Name</div>
            <div>
              {selected.FirstName} {selected.LastName}
            </div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>E-mail</div>
            <div>{selected.Email}</div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>Date responded</div>
            <div>{reverseDate(selected.DateResponded)}</div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>Gift selected</div>
            <div>
              <select
                value={selected.Gift || ''}
                onChange={(e) =>
                  setSelected({ ...selected, Gift: e.target.value })
                }
              >
                {GIFTS.map((gift) => (
                  <option key={gift} value={gift}>
                    {gift}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <br />
          <div className="cg-modal-subtitle">Status</div>
          <div className="flex">
            <div style={{ width: 150 }}>Last updated by</div>
            <div>{selected.LastUpdatedBy}</div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>Order status</div>
            <div>
              <select
                value={selected.StatusOrderInt || ''}
                onChange={(e) =>
                  setSelected({
                    ...selected,
                    StatusOrderInt: Number(e.target.value),
                  })
                }
              >
                {ORDER_STATUSES.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>Invoice status</div>
            <div>
              <select
                value={selected.StatusInvoice || ''}
                onChange={(e) =>
                  setSelected({
                    ...selected,
                    StatusInvoice: e.target.value,
                  })
                }
              >
                {INVOICE_STATUSES.map((invoiceStatus) => (
                  <option key={invoiceStatus} value={invoiceStatus}>
                    {invoiceStatus}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>Comment</div>
            <div>
              <textarea
                style={{ width: 270 }}
                value={selected.Comment || ''}
                onChange={(e) =>
                  setSelected({
                    ...selected,
                    Comment: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="flex" style={{ gap: 12 }}>
            <div style={{ width: 150 }}></div>
            <button
              className="cg-modal-button"
              onClick={() => onSave(selected)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
